import Marionette from 'backbone.marionette';
// import { PlaceholderView } from '../../views';
import { FooterView, HeaderView, HomeView } from '../../views';
import { redirectTo } from '../../../../core/utils';
import HelpController from '../../controllers/Help';
import RankingsController from '../Rankings';

export default class PreseasonController extends Marionette.Object {
	// preseason() {
	// 	this.getOption('rootView')
	// 		.getRegion('main')
	// 		.show(new PlaceholderView());
	// }
	preseason() {
		// this.getOption('rootView')
		// 	.getRegion('main')
		// 	.show(new HomeView());
		const
			rootView = this.getOption('rootView'),
			headerView = new HeaderView(),
			footerView = new FooterView();

		rootView.getRegion('header').show(headerView);
		rootView.getRegion('footer').show(footerView);
		rootView.getRegion('main').show(new HomeView())
	}

	rankingsTipping() {
		const Rankings = new RankingsController({
			rootView: this.getOption( 'rootView' )
		});
		Rankings.rankingsTipping();
	}

	prizes() {
		const Help = new HelpController({
			rootView: this.getOption( 'rootView' )
		});
		Help.prizes();
	}

	redirectToHomePage() {
		redirectTo();
	}
}